import { render, staticRenderFns } from "./TestQuestionTextType.vue?vue&type=template&id=55bc74cb&scoped=true&"
import script from "./TestQuestionTextType.vue?vue&type=script&lang=js&"
export * from "./TestQuestionTextType.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestionTextType.vue?vue&type=style&index=0&id=55bc74cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc74cb",
  null
  
)

/* custom blocks */
import block0 from "./TestQuestionTextType.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./TestQuestionTextType.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VRadio,VRadioGroup,VTextarea})
